import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../auth.service';
import { routerTransition } from "../animations"
import { ActivityComponent } from "../common/activity/activity.component";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': '', '(window:scroll)': 'onScroll($event)'}
})
export class ProfileComponent implements OnInit {

  public profileIdentifier;
  public identifierSubscription;
  public user;

  @ViewChild('userActivityList') private activityList: ActivityComponent;

  constructor(private route: ActivatedRoute,
              private auth: AuthService) { }

  ngOnInit() {

    this.identifierSubscription = this.route.params.subscribe(params => {
      this.profileIdentifier = params['profileId'];
      this.user = this.auth.getUser(this.profileIdentifier);
    });
  }

  onScroll(event) {
    let offset = (event.target.scrollHeight) ? event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight
                                             : event.target.scrollingElement.scrollHeight - event.target.scrollingElement.scrollTop - event.target.defaultView.innerHeight;
    //console.log(offset);
    if(offset < 200) {
      this.activityList.fetchMoreActivity();
    }
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/profile/profile.component.ts